const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHenkel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.27 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Henkel logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M384,363.67c-20.51,0-37.2,9.13-37.2,20.34s16.69,20.33,37.21,20.33,37.21-9.12,37.21-20.33S404.51,363.67,384,363.67Z",
    transform: "translate(-345.87 -362.74)",
    style: {
      fill: "#fff",
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,362.74c21.05,0,38.13,9.52,38.13,21.26S405.05,405.26,384,405.26s-38.14-9.52-38.14-21.26S363,362.74,384,362.74Zm0,1.92c-20,0-36.2,8.68-36.2,19.34S364,403.33,384,403.33s36.21-8.66,36.21-19.33S404,364.66,384,364.66ZM377.3,386h-7.5a2.49,2.49,0,0,0,2.67,2.71,2.16,2.16,0,0,0,2.15-1.31h2.46a4.49,4.49,0,0,1-4.71,3.27c-3.2,0-5.18-2.2-5.18-5.34a5.09,5.09,0,0,1,5.18-5.36C375.83,380,377.5,382.92,377.3,386Zm-5-4.11a2.38,2.38,0,0,0-2.48,2.37h4.88C374.5,382.88,373.9,381.93,372.29,381.93ZM409.8,386h-7.5a2.49,2.49,0,0,0,2.67,2.71,2.16,2.16,0,0,0,2.15-1.31h2.46a4.49,4.49,0,0,1-4.71,3.27c-3.2,0-5.18-2.2-5.18-5.34a5.09,5.09,0,0,1,5.18-5.36C408.32,380,410,382.92,409.8,386Zm-5-4.11a2.38,2.38,0,0,0-2.48,2.37h4.87C407,382.88,406.4,381.93,404.79,381.93Zm-50.73,8.51h2.79v-6h6v6h2.79v-14h-2.79v5.75h-6v-5.75h-2.79Zm24.78,0h2.62v-5.49c0-2.06.73-2.91,2.24-2.91,1.3,0,1.88.83,1.88,2.49v5.9h2.62v-6.24c0-2.51-.75-4.18-3.71-4.18a3.62,3.62,0,0,0-3.1,1.69h-.06v-1.41h-2.48v10.15Zm11.59,0H393v-5.49l3.87,5.49h3.26l-4.26-5.69,3.78-4.46h-3.13L393,384.67v-8.27h-2.62v14Zm20.91,0H414v-14h-2.62Z",
    transform: "translate(-345.87 -362.74)",
    style: {
      fill: "#e1000f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHenkel);
export default __webpack_public_path__ + "static/media/henkel.72a6424a4d127b7d2c068af150e1c405.svg";
export { ForwardRef as ReactComponent };